export const name = 'siteMembersWixCodeSdk' as const
export const namespace = 'user' as const
export const memberNamespace = 'members' as const
export const memberNamespaceV2 = 'members-v2' as const
